import { DSNCWebSourcesSummary } from 'shared-definitions/types'
import { ApiComponentReviewFromWeb } from '../types.wp'

export function ncReviewFromWebMapper(input: ApiComponentReviewFromWeb): DSNCWebSourcesSummary {
  return {
    resource: 'nc-web-sources-summary',
    title: input.title,
    summary: input.review_from_web,
    sourcesTitle: input.sources_title ?? null,
    sources: input.review_from_web_sources.map(source => ({
      label: source.title,
      pLink: {
        href: source.url,
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    })),
  }
}
